export default {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 600,
    semibold: 600,
    bold: 600,
    extrabold: 800,
    black: 900,
}
